import { Component, OnInit, Input } from '@angular/core';
import { Admin } from '@app/core/services/customer-request/model/admin';

@Component({
    selector: 'app-customer-request-admin-name',
    templateUrl: './customer-request-admin-name.component.html',
    styleUrls: ['./customer-request-admin-name.component.css'],
    standalone: false
})
export class CustomerRequestAdminNameComponent implements OnInit {

  @Input() admin: Admin;

  constructor() { }

  ngOnInit() {
  }

}
